import { StandardEvents } from '@shopify/events';

class RchsPartNumber extends HTMLElement {
  #section;
  #request = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#request++;
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = ++this.#request;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || request !== this.#request || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const replacement = Array.from(detail.html.querySelectorAll('rchs-part-number'))
        .find((element) => element.dataset.blockId === this.dataset.blockId);
      if (!replacement) return;
      this.replaceChildren(...Array.from(replacement.childNodes, (node) => node.cloneNode(true)));
      this.dataset.productId = replacement.dataset.productId;
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[rchs-part-number] Variant update failed:', error);
    });
  };
}

if (!customElements.get('rchs-part-number')) {
  customElements.define('rchs-part-number', RchsPartNumber);
}
